/**
 * The banner on a demo dial (KEY-938). Shown to everyone who opens it, every time: a prospect handed the
 * mouse needs to know before they drag a real document in, and an affiliate needs to know which of their two
 * copies this is. The one deliberate difference from a live dial is the one sentence here.
 */
export function DemoNotice({ onReset, resetting = false, error = null }: {
  /** KEY-939: offered to the demo's admins only — puts it back to a fresh copy of its template. */
  onReset?: () => void;
  resetting?: boolean;
  /** Why the last reset did not happen, in the server's words. */
  error?: string | null;
} = {}) {
  const accent = "var(--st-info, #2563eb)";
  return (
    <div
      className="kd-card"
      style={{
        padding: "var(--pad-card, 16px)",
        margin: "0 0 14px",
        borderLeft: `3px solid ${accent}`,
      }}
      role="region"
      aria-label="Demo dial notice"
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <span
          style={{
            fontSize: 11, fontWeight: 700, letterSpacing: ".06em", textTransform: "uppercase",
            color: "#fff", background: accent, borderRadius: 999, padding: "2px 9px",
          }}
        >
          Demo
        </span>
        <h3 style={{ fontSize: 16, fontWeight: 700, margin: 0, color: "var(--text)" }}>
          This is a demo dial — try anything
        </h3>
        {onReset && (
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            style={{ marginLeft: "auto" }}
            disabled={resetting}
            onClick={onReset}
            title="Put the demo back to how it arrived. The people with a place on it keep it."
          >
            {resetting ? "Resetting…" : "Reset demo"}
          </button>
        )}
      </div>
      <p style={{ margin: "8px 0 0", color: "var(--text-muted)", fontSize: 13.5, lineHeight: 1.55 }}>
        Statuses, fields, tables and messages all work as they would for real. Files are the one difference:
        you can go through an upload, but nothing is ever stored in a demo, and the documents already here are
        names only. Everything in it is made up.
      </p>
      {error && <p role="alert" style={{ margin: "8px 0 0", color: "var(--st-overdue)", fontSize: 13 }}>{error}</p>}
    </div>
  );
}
